import type { ReactNode } from "react";
import { T } from "./tokens";

export type V2TabId = "home" | "play" | "lists" | "profile";

interface BottomTabV2Props {
  active: V2TabId;
  onChange: (id: V2TabId) => void;
  labels?: Partial<Record<V2TabId, string>>;
}

const DEFAULT_LABELS: Record<V2TabId, string> = {
  home: "בית",
  play: "נגן",
  lists: "פלייליסטים",
  profile: "פרופיל",
};

interface TabDef {
  id: V2TabId;
  icon: (active: boolean) => ReactNode;
}

const TABS: TabDef[] = [
  {
    id: "home",
    icon: (a) => (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
          d="M3 10 L11 3 L19 10 V18 A1 1 0 0 1 18 19 H14 V13 H8 V19 H4 A1 1 0 0 1 3 18 Z"
          stroke={a ? T.gold : T.mist}
          strokeWidth="1.5"
          fill={a ? `${T.gold}22` : "none"}
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "play",
    icon: (a) => (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <circle
          cx="11"
          cy="11"
          r="9"
          stroke={a ? T.gold : T.mist}
          strokeWidth="1.5"
          fill={a ? `${T.gold}22` : "none"}
        />
        <path d="M9 7.5 L15 11 L9 14.5 Z" fill={a ? T.gold : T.mist} />
      </svg>
    ),
  },
  {
    id: "lists",
    icon: (a) => (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
          d="M3 5 H19 M3 11 H19 M3 17 H13"
          stroke={a ? T.gold : T.mist}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <circle cx="17" cy="17" r="2" fill={a ? T.gold : T.mist} />
      </svg>
    ),
  },
  {
    id: "profile",
    icon: (a) => (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <circle
          cx="11"
          cy="8"
          r="3.5"
          stroke={a ? T.gold : T.mist}
          strokeWidth="1.5"
          fill={a ? `${T.gold}22` : "none"}
        />
        <path
          d="M4 19 C4 15 7 13 11 13 C15 13 18 15 18 19"
          stroke={a ? T.gold : T.mist}
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    ),
  },
];

export function BottomTabV2({ active, onChange, labels }: BottomTabV2Props) {
  const merged = { ...DEFAULT_LABELS, ...(labels ?? {}) };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "8px 12px calc(env(safe-area-inset-bottom) + 12px)",
        direction: "rtl",
        background: `linear-gradient(to top, ${T.navyDeep} 60%, ${T.navyDeep}00)`,
        borderTop: `1px solid ${T.hairline}`,
      }}
    >
      {TABS.map((t) => {
        const a = active === t.id;
        return (
          <button
            key={t.id}
            onClick={() => onChange(t.id)}
            className="nig-tap"
            style={{
              background: "transparent",
              border: 0,
              padding: "6px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 3,
              color: a ? T.gold : T.mist,
              fontFamily: T.sans,
              fontSize: 10.5,
              fontWeight: 500,
              transition: "color 0.2s",
            }}
          >
            {t.icon(a)}
            <span>{merged[t.id]}</span>
          </button>
        );
      })}
    </div>
  );
}
